import moment from "moment";
import { capitalizeFirstLetter } from '@/utils'
import ordinal from 'ordinal';
import { getSignatureText } from "../utils";
import { mapGetters } from "vuex";
import calculateFees from '@/mixins/calculate-fees'

export default {
  mixins: [calculateFees],
  data: () => ({
    feesTotal: 0,
  }),
  computed: {
    ...mapGetters({
      currentCase: "eviction/currentCase",
      currentProperty: "property/currentProperty",
    }),
    getCourtAddress() {
      return this.mileage.courtAddress;
    },
    getCourtFee() {
      // const courtFee = this.currentCase.tenants.length === 3 ? 65 : 50;
      const calculateTotalCourtFee = 50 + (5 * this.currentCase.tenants.length) + parseInt(this.getMileageFee);
      return parseFloat(calculateTotalCourtFee).toFixed(2);
    },
    getMileageFee() {
      let mileageFeeAmount = '';
      this.currentCase.legalFees && this.currentCase.legalFees.map((item) => {
        if (item.type === 'Mileage Fee') {
          mileageFeeAmount = item.amount;
        }
      });

      return mileageFeeAmount || "0.00";
    },
    fees() {
      return {
        courtFee: this.getCourtFee,
        mileageFee: this.getMileageFee,
      };
    },
  },
  methods: {
    async getTemplateData() {
      await this.initFeeData();
      const contactInfo = this.currentProperty.contactInfo || {}

      this.feesTotal = this.getSummaryTotal

      const getUnitNo = this.currentProperty.unitNo ? `, ${this.currentProperty.unitNo}` : '';

      const signatureText = getSignatureText(this.currentProperty);

      let entityTypeStatement = null;
      const { clientType, ownershipType } = this.currentProperty;

      if (clientType === 'agent' && ownershipType !== "Individual") {
        entityTypeStatement = 'An attorney will be representing the Plaintiff at the hearing.'
      }

      return {
        heading: {
          name: `${contactInfo.firstName} ${contactInfo.lastName}`,
          addressLine1: contactInfo.streetAddress,
          addressLine2: `${contactInfo.city}, ${contactInfo.state} ${contactInfo.zipcode}`,
          county: this.getCourtAddress.county,
          courtCity: this.getCourtAddress.city,
          courtState: this.getCourtAddress.state,
          courtZipcode: this.getCourtAddress.zipcode,
          courtPhone: this.getCourtAddress.phone,
          courtExt: this.getCourtAddress.ext,
          phone: contactInfo.phone,
          email: contactInfo.email,
          ...this.getCourtStreetAddresses(),
        },
        ...this.fees,
        entityTypeStatement,
        phone: contactInfo.phone,
        email: contactInfo.email,
        ownerName: this.ownerOfRecord(),
        clientName: `${this.client.firstName} ${this.client.lastName}`,
        superiorCourtZipcode: this.courtInfo.superiorCourtZipcode,
        docketNo: ``,
        clientSignatureTitle: ``,
        tenantNames: this.compileTenants(),
        tenantAddress: `${this.case.property.streetAddress}${getUnitNo}, ${this.case.property.city}, ${this.case.property.state} ${this.case.property.zipcode}`,
        tenantPhone: this.case.tenantPhone,
        tenantEmail: this.case.tenantEmail,
        deedNames: this.ownerOfRecord(),
        clientType: this.clientType(),
        propertyType: this.case.leaseTypeTitle,
        ownership: this.case.confirmation.ownership.confirmed,
        optionToPurchase: this.case.confirmation.option_to_purchase.confirmed,
        leaseStartDate: this.$dayjs(this.case.leaseStartDate).format("MMM DD, YYYY"),
        section8: this.case.section8,
        rentAmount: this.case.section8 ? this.convertToCurrency(this.case.section8TenantPortion) : this.convertToCurrency(this.case.rentAmount),
        rentCycleAndDueBy: this.formatRentCycle(),
        amounts: this.compileAmountsOwed(),
        total: this.dollarFormat(this.feesTotal),
        nextRentDueDate: this.nextRentDue(),
        nextAmount: this.calculateNextAmount(),
        registeredLease: ``,
        clientDescription: this.clientTypeExtended(),
        otherCourtAction: this.case.verification.another_court_subject.confirmed,
        otherParty: this.case.verification.another_court_subject.party,
        interpreter: this.case.verification.interpreter.language,
        disability: this.case.verification.disability.accommodation,
        filingPlan: this.case.filingPlan,
        signatureImage: this.case.signatureImage ? `https://fileevictions.nyc3.digitaloceanspaces.com/${this.case.signatureImage}` : 'https://fileevictions.nyc3.digitaloceanspaces.com/e-signature-white.png',
        signatureText,
        signatureText1: signatureText.split(', ')[0].trim(),
        signatureText2: signatureText.split(', ').filter((value, key) => key !== 0).join(', ').trim(),
        signature: this.case.signature
          ? this.case.signature
          : "https://dummyimage.com/50x50/fff/fff",
        date: moment().format("MM/DD/YYYY"),
        legalServicesTel: this.courtInfo.legalServices,
        lawyerReferralTel: this.courtInfo.lawyerReferral,
        welfareAgencyTel: this.courtInfo.housingServicePhone,
        welfareAgencyAddress: `${this.courtInfo.housingServiceStreet}, ${this.courtInfo.housingServiceCity}, ${this.courtInfo.housingServiceState} ${this.courtInfo.housingServiceZipcode}`,
      };
    },
    getCourtStreetAddresses() {
      const courtStreetAddress = this.getCourtAddress.street.split(",");
      const obj = {}
      courtStreetAddress.forEach((street, key) => {
        obj[`courtStreetAddress${key + 1}`] = street.trim()
      })

      return obj;
    },
    compileTenants() {
      if (this.case.tenantCompanyName) {
        return this.case.tenantCompanyName;
      }

      const tenants = this.case.tenants;

      const lastKey = tenants.length - 1;

      let tenantNames = '';

      for (const [key, tenant] of tenants.entries()) {
        if (tenantNames !== "") {
          if (tenants.length === 2) {
            tenantNames += " and ";
          } else if (key === lastKey) {
            tenantNames += ", and ";
          } else {
            tenantNames += ", ";
          }
        }

        tenantNames += capitalizeFirstLetter(tenant.name);
      }

      return tenantNames;
    },
    ownerOfRecord() {
      //if empty, return empty string
      if (!this.case.property.deedNames) return "";
      //if DeedNames is from a saved property, the type will be string
      if (typeof this.case.property.deedNames === "string") {
        return this.case.property.deedNames;
      }
      // let deedNames = ''
      // for (const deedName of this.case.property.deedNames){
      //     if (deedNames !== ''){deedNames += ', '}
      //     deedNames += deedName
      // }
      return this.case.property.deedNames.join(", ");
    },
    clientType() {
      if (this.currentProperty.clientType === "owner") {
        return "Owner";
      }

      return "Agent"
    },
    formatRentCycle() {
      switch (this.case.rentCycle) {
        case "Monthly":
          return `on the ${ordinal(parseInt(this.case.rentDueBy))} day of each month`;
        case "Weekly":
          return `every ${this.numberToDay(this.case.rentDueBy)}`;
        case "Bi-weekly":
          return `every other ${this.numberToDay(this.case.rentDueBy)}`;
        case "Semi-monthly":
          return `on the ${ordinal(parseInt(this.case.rentDueBy[0]))} and ${ordinal(parseInt(this.case.rentDueBy[1]))} of each month`;
        default:
          return "MISSING RENT DUE BY DAY";
      }
    },
    compileAmountsOwed() {
      // let total = 0;
      let amountsOwed = [];
      // let amountsOwed = [
      //                 [{text: 'PERIOD', bold: true}, {text: 'DESCRIPTION', bold: true}, {text: 'AMOUNT', bold: true}],
      //                 ]
      this.case.pastDueRent.filter(value => value.selected).forEach((fee) => {
        if (fee.amount) {
          amountsOwed.push({
            timeperiod: fee.timePeriodDisplay,
            description: "Rent",
            amount: `$${parseFloat(fee.amount).toFixed(2)}`,
          });
          // total += parseFloat(fee.amount);
        }
      });

      this.case.lateCharges.forEach((fee) => {
        if (fee.amount) {
          amountsOwed.push({
            timeperiod: fee.timePeriodDisplay,
            description: "Late Fee *",
            amount: `$${parseFloat(fee.amount).toFixed(2)}`,
          });
          // total += parseFloat(fee.calculatedAmount);
        }
      });

      this.case.utilities.forEach((fee) => {
        if (fee.amount) {
          amountsOwed.push({
            timeperiod: fee.timePeriodDisplay,
            description: `Utilities: ${fee.type} *`,
            amount: `$${parseFloat(fee.amount).toFixed(2)}`,
          });
          // total += parseFloat(fee.amount);
        }
      });

      this.case.fees.forEach((fee) => {
        if (fee.amount) {
          amountsOwed.push({
            timeperiod: fee.timePeriodDisplay,
            description: `${fee.type} *`,
            amount: `$${parseFloat(fee.amount).toFixed(2)}`,
          });
          // total += parseFloat(fee.amount);
        }
      });

      this.case.otherCharges.forEach((fee) => {
        if (fee.amount) {
          amountsOwed.push({
            timeperiod: fee.timePeriodDisplay,
            description: `${fee.type} *`,
            amount: `$${parseFloat(fee.amount).toFixed(2)}`,
          });
          // total += parseFloat(fee.amount);
        }
      });

      amountsOwed.sort((a, b) => {
        if (a.timeperiod && b.timeperiod) {
          return this.compareDateRange(a.timeperiod, b.timeperiod);
        }
      });
      // //once sorted, add header
      // amountsOwed.unshift(
      //                [{text: 'PERIOD', bold: true}, {text: 'DESCRIPTION', bold: true}, {text: 'AMOUNT', bold: true}],
      //                )
      //add legal fees to bottom
      if (this.case.legalFeesPermitted) {
        // let attorneyLegalFeesTotal =
        //   parseFloat(this.total(this.case.legalFees[0].costs)) +
        //   parseFloat(this.total(this.case.legalFees[2].costs)) +
        //   parseFloat(this.total(this.case.legalFees[3].costs));
        // amountsOwed.push({
        //   timeperiod: "",
        //   description: "Attorney Fees *",
        //   amount: `$${attorneyLegalFeesTotal.toFixed(2)}`,
        // });
        // total += attorneyLegalFeesTotal;
        // let courtFeesTotal = parseFloat(
        //   this.total(this.case.legalFees[1].costs)
        // );
        let courtFeesTotal = 0;

        this.case.legalFees && this.case.legalFees.forEach((value) => {
          courtFeesTotal += parseInt(value.amount);
        })

        amountsOwed.push({
          timeperiod: "",
          description: "Court Fees *",
          amount: `$${courtFeesTotal.toFixed(2)}`,
        });

        // total += courtFeesTotal;
      }
      //amountsOwed.push(['', {text: 'TOTAL', bold: true}, {text: `$${total.toFixed(2)}`, bold: true}])
      // this.feesTotal = `$${total.toFixed(2)}`;
      return amountsOwed;
    },
    dollarFormat(number) {
      return `$${parseInt(number).toFixed(2)}`;
    },
    compareDateRange(dateRange1, dateRange2) {
      const date1 = moment(dateRange1.slice(0, 8));
      const date2 = moment(dateRange2.slice(0, 8));
      if (date1.isSame(date2)) {
        const date3 = moment(dateRange1.slice(11, 19));
        const date4 = moment(dateRange2.slice(11, 19));
        if (date3.isSame(date4)) {
          return 0;
        } else if (date3.isBefore(date4)) {
          return -1;
        }
        return 1;
      } else if (date1.isBefore(date2)) {
        return -1;
      }
      return 1;
    },
    nextRentDue() {
      const today = moment();
      let dueDate = "";
      switch (this.case.rentCycle) {
        case "Monthly":
          if (today.date() < parseFloat(this.case.rentDueBy)) {
            dueDate = moment([
              today.year(),
              today.month(),
              parseFloat(this.case.rentDueBy),
            ]);
            this.rentDueBeforeTrial = dueDate;
          } else {
            dueDate = moment([
              today.year(),
              today.add(1, "months").month(),
              parseFloat(this.case.rentDueBy),
            ]);
            this.rentDueBeforeTrial = dueDate;
          }
          return dueDate.format("MM/DD/YYYY");
        case "Weekly":
          return this.getNextDayOfTheWeek(
            this.case.rentDueBy,
            true,
            today
          ).format("MM/DD/YYYY");
        // case 'Bi-weekly':
        //     return `every other ${this.case.rentDueBy}`
        case "Semi-monthly":
          if (today.date() < parseFloat(this.case.rentDueBy[0])) {
            dueDate = moment([
              today.year(),
              today.month(),
              parseFloat(this.case.rentDueBy[0]),
            ]);
            this.rentDueBeforeTrial = dueDate;
          } else if (today.date() < parseFloat(this.case.rentDueBy[1])) {
            dueDate = moment([
              today.year(),
              today.month(),
              parseFloat(this.case.rentDueBy[1]),
            ]);
            this.rentDueBeforeTrial = dueDate;
          } else {
            dueDate = moment([
              today.year(),
              today.add(1, "months").month(),
              parseFloat(this.case.rentDueBy[0]),
            ]);
            this.rentDueBeforeTrial = dueDate;
          }
          return dueDate.format("MM/DD/YYYY");
        default:
          return "MISSING INFORMATION";
      }
    },
    getNextDayOfTheWeek(dayName, excludeToday = true, refDate = moment()) {
      let addedDays =
                +excludeToday +
                ((this.dayToNumber(dayName) + 7 - refDate.day() - +excludeToday) % 7);
      return refDate.add(addedDays, "days");
    },
    numberToDay(number) {
      switch (parseInt(number)) {
        case 0:
          return "Sunday";
        case 1:
          return "Monday";
        case 2:
          return "Tuesday";
        case 3:
          return "Wednesday";
        case 4:
          return "Thursday";
        case 5:
          return "Friday"
        case 6:
          return "Saturday";
      }
    },
    dayToNumber(day) {
      switch (day) {
        case "Sunday":
          return 0;
        case "Monday":
          return 1;
        case "Tuesday":
          return 2;
        case "Wednesday":
          return 3;
        case "Thursday":
          return 4;
        case "Friday":
          return 5;
        case "Saturday":
          return 6;
      }
    },
    calculateNextAmount() {
      const calcTotal = this.feesTotal + this.case.rentAmount;

      return this.dollarFormat(calcTotal);
    },
    clientTypeExtended() {
      if (!this.currentProperty.contactInfo) return console.error("currentProperty.contactInfo is missing");

      const { clientType, ownershipType } = this.currentProperty

      switch (ownershipType) {
        case "Individual":
          if(clientType === "owner")
            return "Landlord";
          else
            return "agent for the Owner";
        case "General Partnership":
          if (clientType === "owner") return 'general partner of the partnership';
          else return "agent for the Owner";
        case "Corporation":
          if(clientType !== "owner") return 'authorized officer of a corporation';
          break;
        default:
          return 'authorized officer of a limited liability company'
      }    
    },

  }
}